export default __webpack_public_path__ + "static/roadmap_75-fcd32333b356c0b8e7cb61033cab8b71.png";